/* Размеры из вёрстки (item__pictureWrapper в MainNews.vue). */
export const MAIN_NEWS_IMAGE_DESKTOP_WIDTH = 500;
export const MAIN_NEWS_IMAGE_TABLET_WIDTH = 352;
export const MAIN_NEWS_IMAGE_MOBILE_WIDTH = 560;
